module.exports = __webpack_public_path__ + "img/full4-min.8e211f3b.png";